import React from 'react';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { Box, Chip, ChipProps, Tooltip } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { commonStyles } from '~/modules/covenants/CovenantsDataForm/commonStyles.ts';
import { covComponentsStyles } from '~/modules/covenants/components/styles.ts';

interface IStatusChipWithTooltipProps {
  label: string;
  color: ChipProps['color'];
  description?: string;
  size?: 'small' | 'medium';
  chipSx?: SxProps<Theme>;
}

export const StatusChipWithTooltip: React.FC<IStatusChipWithTooltipProps> = ({
  label,
  color,
  description,
  size = 'small',
  chipSx,
}) => {
  return (
    <Box component="span" sx={covComponentsStyles.statusWithInfo}>
      <Chip
        label={<Box component="span" sx={covComponentsStyles.statusLabel}>{label}</Box>}
        color={color}
        size={size}
        variant="filled"
        sx={chipSx ?? commonStyles.statusChip}
      />
      {description && (
        <Tooltip
          title={description}
          placement="bottom-start"
          slotProps={{
            tooltip: { sx: covComponentsStyles.statusTooltip },
          }}
        >
          <Box
            component="span"
            tabIndex={0}
            role="button"
            aria-label={`Опис статусу "${label}"`}
            sx={covComponentsStyles.statusInfo}
          >
            <InfoOutlinedIcon sx={{ fontSize: size === 'medium' ? 27 : 24 }} />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};
